import { useForm } from "antd/es/form/Form";
import React, { useEffect, useState } from "react";

import { IAccountCreate } from "../../../../models/account";
import { FormProps } from "antd/lib";
import { Form, Input, Modal } from "antd";
import { useAppDispatch } from "../../../../lib/hook";
import { onCreateAccount } from "../../../../lib/features/accounts/accounts.thunk";

interface ModalCreateAccountProps {
  visible: boolean;
  onClose: () => void;
}

const ModalCreateAccount: React.FC<ModalCreateAccountProps> = (
  props: ModalCreateAccountProps
) => {
  const { visible, onClose } = props;
  const [loading, setLoading] = useState(false);
  const [form] = useForm();
  const dispatch = useAppDispatch();
  const onFinish: FormProps<IAccountCreate>["onFinish"] = async (values) => {
    setLoading(true);

    await dispatch(onCreateAccount(values)).then(
      (result) => {
        if (result?.type.includes("fulfilled")) {
          form.resetFields();
          onClose && onClose();
          setLoading(false);
        }
      }
    );

    setLoading(false);
  };
  useEffect(() => {
    if (visible) {
      return () => {
        form.resetFields();

        setLoading(false);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);
  return (
    <Modal
      loading={loading}
      title="Tạo tài khoản"
      open={visible}
      onCancel={onClose}
      onOk={() => form.submit()}
      confirmLoading={loading}
    >
      <Form
        disabled={loading}
        layout="vertical"
        form={form}
        onFinish={onFinish}
        autoComplete="off"
        className="mt-3"
      >
        <Form.Item<IAccountCreate>
          label="Họ và tên"
          name="fullName"
          rules={[{ required: true, message: "Mời điền họ và tên" }]}
          style={{ marginBottom: 8 }}
        >
          <Input placeholder="Nhập tên" />
        </Form.Item>
        <Form.Item<IAccountCreate>
          label="Số điện thoại "
          name="phone"
          rules={[{ required: true, message: "Mời điền số điện thoại" }]}
          style={{ marginBottom: 8 }}
        >
          <Input placeholder="Nhập số điện thoại" />
        </Form.Item>
        <Form.Item<IAccountCreate>
          label="Email"
          name="email"
          rules={[{ required: true, message: "Mời điền email" }]}
          style={{ marginBottom: 8 }}
        >
          <Input placeholder="Nhập email" />
        </Form.Item>
        <Form.Item<IAccountCreate>
          label="Mật khẩu"
          name="password"
          rules={[{ required: true, message: "Mời điền mật khẩu" }]}
          style={{ marginBottom: 8 }}
        >
          <Input placeholder="Nhập mật khẩu" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalCreateAccount;
